<template>
  <!-- <v-navigation-drawer
		v-model="drawer"
		color="primary"
		disable-resize-watcher
	>
		<v-list nav>
			<v-list-item
				v-for="(item, i) in navigationItems"
				:key="i"
				:active="i === 0"
				link
				:title="item.text"
			/>
		</v-list>
	</v-navigation-drawer> -->
  <!-- <v-container> -->
  <v-app-bar
    name="app-bar"
    density="compact"
    class="pa-2 px-md-4"
    scroll-behavior="inverted elevate"
    :flat="isAtTop"
    :elevation="isAtTop ? '0' : '4'"
    scroll-threshold="150"
    :style="headerStyle"
  >
    <template #default>
      <v-container max-width="1440" class="pa-0 mx-auto">
        <v-row no-gutters class="flex-nowrap align-center">
          <!-- Logo -->
           <NuxtLink to="/">
             <NuxtImg
             src="/assets/brand/logo.svg"
             :alt="`Logo de ${companyInfo.name}`"
             width="70px"
             preload
             />
           </NuxtLink>
          <v-spacer/>
          <!-- Desktop Navigation -->
          <v-row
          no-gutters
          justify="center"
          class="ma-0 d-none d-md-flex flex-grow-1"
          >
          <v-btn
          v-for="item in navigationItems"
              :key="item.to"
              :density="mobile ? 'compact' : 'default'"
              :size="mobile ? 'small' : 'large'"
              :to="`/${item.to}`"
              :text="item.text"
              class="mx-1 px-2 px-md-3 font-weight-bold"
              variant="plain"
            />
          </v-row>
          <v-spacer/>
          <!-- Botón toggle de tema claro/oscuro -->
          <v-btn
            icon
            variant="text"
            :aria-label="
              isDark ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'
              "
            class="mx-1"
            @click="toggleTheme"
          >
            <v-icon
              :icon="isDark ? '$mdiWeatherSunny' : '$mdiWeatherNight'"
            ></v-icon>
          </v-btn>
          <v-btn
            v-if="companyInfo"
            variant="elevated"
            class="mx-1"
            :rounded="smAndDown ? 'circle' : 'pill'"
            :aria-label="`Contactar a ${companyInfo.name}`"
            color="green"
            :prepend-icon="smAndDown ? false : '$mdiWhatsapp'"
            :icon="smAndDown ? '$mdiWhatsapp' : false"
            href="https://api.whatsapp.com/send?phone=584123210216"
            :text="!smAndDown ? 'Contactar' : undefined"
          >
          </v-btn>
        </v-row>
      </v-container>
    </template>
  </v-app-bar>
  <!-- </v-container> -->
</template>

<script setup lang="js">
import companyInfo from "~/data/companyInfo";
import { useTheme } from "vuetify";
import { useConfigStore } from "~/stores/config"; // Importar el store de configuración
import { useDisplay } from "vuetify";
import { computed } from "vue";
// State
const { mobile, smAndDown } = useDisplay();
const drawer = ref(false);
const scrollY = ref(0);
const configStore = useConfigStore(); // Usar el store

// Computed
const isAtTop = computed(() => scrollY.value === 0);
const headerStyle = computed(() => ({
  backgroundColor: isAtTop.value
    ? "transparent"
    : "rgba(var(--v-theme-ternary), 0.3)",
  backdropFilter: isAtTop.value ? "none" : "blur(10px)",
  transition: "all 0.3s ease-in-out",
}));

// Navigation Items
const navigationItems = [
  { text: "Beneficios", to: "#insights" },
  { text: "Funcionalidades", to: "#functionalities" },
  // { text: "Planes", to: "#pricing" },
  { text: "Nosotros", to: "#about" },
  // { text: "Contacto", to: "/contacto" },
];
// Theme management
const vuetifyTheme = useTheme();
const isDark = computed(() => configStore.getCurrentTheme === "dark");

const toggleTheme = async () => {
  configStore.toggleTheme(); // Usar la acción del store
  vuetifyTheme.global.name.value = configStore.getCurrentTheme;

  // Actualizar tema de partículas si existe
  if (process.client) {
    const particlesContainer = document.getElementById("tsparticles");
    if (particlesContainer) {
      try {
        const { getInstanceByDom } = await import("@tsparticles/engine");
        const particles = getInstanceByDom(particlesContainer);
        if (particles) {
          particles.setTheme(configStore.getCurrentTheme);
        }
      } catch (error) {
        console.warn("Error al actualizar el tema de tsparticles:", error);
      }
    }
  }
};

// Scroll handler
const handleScroll = () => {
  scrollY.value = window.scrollY;
};

// Lifecycle
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  // Set initial scroll position
  scrollY.value = window.scrollY;
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style lang="scss" scoped>
// .v-app-bar {
// 	// z-index: 100;

// 	// &.transparent-header {
// 	// 	background: transparent !important;
// 	// 	box-shadow: none !important;
// 	// }
// }
// 	.glass-card.glass-card.glass-card.glass-card.glass-card {
//   /* Usamos variables de Vuetify para que se adapte al tema claro/oscuro */
// backgroundColor: isAtTop.value ? 'transparent' : 'rgba(var(--v-theme-ternary), 0.3)',
// backdropFilter: isAtTop.value ? 'none' : 'blur(10px) blur(2px)',
// WebkitBackdropFilter: isAtTop.value ? 'none' : 'blur(2px)', // Compatibilidad Safari
// border: isAtTop.value ? 'none' : '1px solid rgba(var(--v-theme-outline-rgb), 0.2)',
// transition: 'all 0.3s ease-in-out'
// }
</style>
